import { createContext } from 'react'

export const GlobalCasesContext = createContext({})
